export default "__VITE_ASSET__CSKnSnU0__"